module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Change payment period","select":"Any change in your billing period will take effect at the end of the current billing period. Your choice will affect the amount you will be charged when your subscription is renewed. Right now, your card will not be charged."}}')
  delete Component.options._Ctor
}
